import { Link } from 'react-router-dom';
import commonCss, { mobileView } from '../commonCss/commonCss';
import { StyleSheet, css } from 'aphrodite';

export function AppFooter() {
  return (
    <footer>
      <div
        className={css(
          commonCss.flexRow,
          commonCss.alignItemsCenter,
          commonCss.justifySpaceBetween,
          styles.footer,
        )}
      >
        <div>Copyright © 2022 Sangini Jewellers - All Rights Reserved.</div>
        <div className={css(styles.textRight)}>Sole Proprietorship</div>
      </div>
      <div
        className={css(
          commonCss.flexRow,
          commonCss.alignItemsCenter,
          commonCss.justifySpaceBetween,
          styles.footerContent,
        )}
      >
        <Link to="/privacyPolicy" className={css(styles.privacyLink)}>
          Privacy Policy
        </Link>
        <Link to="/termsandcondition" className={css(styles.privacyLink)}>
          Terms And Condition
        </Link>
      </div>
    </footer>
  );
}

const styles = StyleSheet.create({
  footer: {
    margin: '50px 10% 0 10%',
    padding: '25px 0 20px 0',
    [mobileView]: {
      margin: '10% 10px',
      fontSize: '0.8rem',
    },
    borderTop: '1px solid #ccc',
    color: '#666',
  },
  textRight: {
    textAlign: 'right',
  },
  footerContent: {
    margin: '0px 10% 0 10%',
    padding: '25px 0 10px 0',
    [mobileView]: {
      margin: '10% 10px',
      fontSize: '0.8rem',
    },
    textDecoration: 'none',
  },
  privacyLink: {
    textDecoration: 'none',
    color: 'inherit',
  },
});
